export default "__VITE_PUBLIC_ASSET__617319a4__"